export default "__VITE_ASSET__BRCuUi5J__"